import { http, HttpResponse } from 'msw';
import { integrationFactory } from '@trukt/factories/integrationFactory';
import { mockTruktTmsApiUrl } from '../mocks';
import {
  InvoiceIntegrationSearchResponse,
  InvoiceIntegrationAppListSearchResponse,
  InvoiceIntegrationAppConfigResponse,
} from '../services/InvoiceIntegrationService';

export const handlers = [
  http.get(mockTruktTmsApiUrl('/invoices/:invoiceGuid/integrations'), () => {
    return HttpResponse.json<InvoiceIntegrationSearchResponse>(integrationFactory.buildList(3));
  }),
  http.get(mockTruktTmsApiUrl('/integrations/apps'), () => {
    return HttpResponse.json<InvoiceIntegrationAppListSearchResponse>({
      page: 0,
      rows: 10,
      next: false,
      results: [
        {
          id: '1004779',
          name: 'COUPA',
          status: 'S',
          isEnabled: false,
          errorMessage: null,
          dateConnectionCheck: null,
        },
        {
          id: '1004780',
          name: 'NETSUITE',
          status: 'S',
          isEnabled: true,
          errorMessage: null,
          dateConnectionCheck: null,
        },
      ],
    });
  }),
  http.get(mockTruktTmsApiUrl('/integrations/:appId/configs'), () => {
    return HttpResponse.json<InvoiceIntegrationAppConfigResponse>([
      {
        id: '3014288',
        key: 'base_URL',
        value: 'http://prod1.boomi.acertusdelivers.com:9090',
        isEncrypted: false,
      },
      {
        id: '3010779',
        key: 'bill_configs',
        value: '{"allowed": true}',
        isEncrypted: false,
      },
      {
        id: '3017318',
        key: 'bill_URL',
        value: 'https://3651230-sb1.app.netsuite.com/app/accounting/transactions/vendbill.nl?id=',
        isEncrypted: false,
      },
      {
        id: '1072067',
        key: 'COMPANY_EXPORT_COUNT',
        value: '6',
        isEncrypted: false,
      },
      {
        id: '3010778',
        key: 'invoice_configs',
        value: '{"allowed": true}',
        isEncrypted: false,
      },
      {
        id: '1072066',
        key: 'INVOICE_EXPORT_COUNT',
        value: '100',
        isEncrypted: false,
      },
      {
        id: '3017238',
        key: 'invoice_URL',
        value: 'https://3651230-sb1.app.netsuite.com/app/accounting/transactions/custinvc.nl?id=',
        isEncrypted: false,
      },
      {
        id: '3014289',
        key: 'password',
        value: '*',
        isEncrypted: true,
      },
      {
        id: '3014290',
        key: 'user_name',
        value: 'metrogisticsllc-EXSFAI',
        isEncrypted: false,
      },
    ]);
  }),
  http.patch(mockTruktTmsApiUrl('/invoices/:invoiceGuid/integrations/:integrationId'), () => {
    return HttpResponse.json();
  }),
];
